<div class="widget" [ngClass]="{'loader-shown': loading, 'initial': notStarted, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-form" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-progress-bar">
        <div class="loader-element loader-circle"></div>
      </div>
      <div class="loader-element loader-button"></div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <span class="custom-icon" aria-hidden="true">
      <span class="icon material-icons">assignment</span>
    </span>
    <span class="title">{{ formName }}</span>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">

      <div *ngIf="!stageId">Not connected to a stage</div>

      <div
        class="progress-bar"
        [style.background]="background"
        [attr.data-percentage]="percentage"
        *ngIf="stageId && !isDeadlinePassed && !isSubmitted && !notStarted && !isEliminated"
      >
        <span class="sr-only">Form completeness is:</span>
        <progress
          [value]="percentage"
          min="0"
          max="100"
          role="progressbar"
          attr.aria-label="{{percentage}} percent form completeness"
          [attr.aria-valuenow]="percentage"
        >
          {{ percentage }}%
        </progress>
      </div>

      <div *ngIf="stageId && isDeadlinePassed && !isSubmitted && !isEliminated && !notStarted" class="custom-message">
        <span class="icon material-icons passed-deadline" aria-hidden="true">cancel</span>
        <p>We regret to inform you that you will not advance forward in the competition.</p>
      </div>

      <div *ngIf="stageId && isSubmitted && !isEliminated && !notStarted" class="custom-message">
        <span class="icon material-icons submitted" aria-hidden="true">check_circle</span>
        <p>Thank you for submitting your application!</p>
      </div>

      <div *ngIf="stageId && isEliminated && !notStarted" class="custom-message">
        <span class="icon material-icons passed-deadline" aria-hidden="true">cancel</span>
        <p>{{ formName }} not submitted within deadline. You won't advance to next stage.</p>
      </div>

      <div *ngIf="stageId && notStarted" class="default-state">
        <img src="assets/images/widget/lock.webp"/>
        <span class="inner-title">{{ formName }}</span>
        <span class="inner-message">Unlocking soon...</span>
      </div>

      <button
        class="button"
        [ngClass]="!isDeadlinePassed && !isSubmitted? 'button-primary' : 'button-secondary'"
        *ngIf="stageId && !notStarted && !isEliminated"
        [routerLink]="buttonLink"
        [attr.aria-label]="buttonText + ' form'"
      >         
        {{ buttonText }}
      </button>
   
  </div>
</div>